"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            QuickFilter_ApplyButtonTooltip: "Apply filter",
            QuickFilter_ClearButtonTooltip: "Clear",
            QuickFilter_Field: "Field",
            QuickFilter_PlaceHolderText: "Filter"
        }
    });
    var controls;
    (function (controls) {
        var QuickFilter = /** @class */ (function (_super) {
            __extends(QuickFilter, _super);
            function QuickFilter() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * Apply the quickfilter using the selected field and value in the input control.
                 * @internal
                 */
                _this.callApplyFilter = function () {
                    var field = _this.selectedField();
                    var filterValue = $dyn.value(_this.InputValue);
                    _this.closeFieldPicker();
                    if (!($dyn.value(_this.Value) === "" && filterValue === "")) {
                        $dyn.setValue(_this, "Value", filterValue);
                        $dyn.setValue(_this, "Field", field);
                        var curValue = $dyn.value(_this.Value).trim();
                        if (!((curValue === _this.previousValue && $dyn.value(_this.selectedIndex) === _this.preSelectedIndex) || (curValue === "" && _this.previousValue === ""))) {
                            _this.previousValue = curValue;
                            _this.preSelectedIndex = $dyn.value(_this.selectedIndex);
                            var options_1;
                            if (curValue === "") {
                                options_1 = { userDefined1: 0, extendedData: field };
                            }
                            else {
                                options_1 = { userDefined1: 1, extendedData: field };
                            }
                            _this.telemetryEventArgs = $dyn.telemetry.addControlActionEvent(_this, _this.telemetryEventArgs, $dyn.telemetry.ActionEvents.quickFilter, options_1);
                        }
                        $dyn.getFunction(_this.ApplyFilter)();
                    }
                };
                /**
                 * KeyDown event binding handler.
                 * @internal
                 * @param evt The event.
                 */
                _this.keyDown = function (evt) {
                    if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.util.Lookup.KeysToSendToLookup })) {
                        // Need to prevent down and up arrows from changing focus in the input in Chrome.
                        // Need to prevent 'enter' from causing a click event if there is a button on the form without type='button'
                        evt.preventDefault();
                        // Prevent the keyDown from bubbling so the form level enter shortcut is prevented.
                        // See documentation on this behavior in $dyn.ui.Control constructor.
                        evt.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut.");
                    }
                    else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.tab, isShiftKeyAgnostic: true })) {
                        _this.closeFieldPicker();
                    }
                };
                /**
                 * KeyUp event binding handler.
                 * @internal
                 * @param evt The event.
                 */
                _this.keyUp = function (evt) {
                    var dropDownOpen = $dyn.value(_this.ShowFieldPicker);
                    var dropDownShouldOpen = false;
                    if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.enter })) {
                        _this.callApplyFilter();
                    }
                    else {
                        if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.downArrow })) {
                            dropDownShouldOpen = true;
                            if (dropDownOpen) {
                                _this.nextItem();
                            }
                        }
                        else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.upArrow })) {
                            dropDownShouldOpen = true;
                            if (dropDownOpen) {
                                _this.previousItem();
                            }
                        }
                    }
                    if (dropDownShouldOpen && !dropDownOpen) {
                        // Only open the dropdown if it is not already open.
                        _this.openFieldPicker();
                    }
                };
                /**
                 * TextChanged event binding handler.
                 * @internal
                 */
                _this.TextChanged = function () {
                    // Can't directly bind to 'Value' of input, since that causes undesired behavior such as resetting cursor while typing.
                    var dropDownOpen = $dyn.value(_this.ShowFieldPicker);
                    var input = _this.$controlElement.find("input");
                    if (input.length === 1) {
                        var inputVal = input.val();
                        _this.TypedValue(inputVal);
                        if (inputVal === "") {
                            _this.$controlElement.removeClass("noPlaceHolder");
                            if (dropDownOpen) {
                                // Close the dropdown if the input is now blank
                                _this.closeFieldPicker();
                            }
                        }
                        else {
                            _this.$controlElement.addClass("noPlaceHolder");
                            if (!dropDownOpen) {
                                // Open the dropdown if it is not already open.
                                _this.openFieldPicker();
                            }
                        }
                    }
                };
                /**
                 * This method is passed into the simpleFlyout handler of the field selector dropdown to handle click events.
                 * options params should be defined by flyoutManager. It has is an aggregate element that consists of:
                 * clickTarget, flyoutElement, clickY, clickY
                 * @internal
                 * @param options The flyout click subscriber options
                 * @returns True if the flyout was closed by the click.
                 */
                _this.flyoutClickSubscriber = function (options) {
                    if (!(options.clickTarget.tagName.toLowerCase() === "input" && $.contains(_this.element, options.clickTarget))) {
                        return $dyn.util.flyout.defaultFlyoutClickSubscriber(options);
                    }
                };
                return _this;
            }
            QuickFilter.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.$controlElement = $(element);
                this.LayoutWidth = $dyn.computed(function () {
                    var width = $dyn.value(_this.Width);
                    if (width === $dyn.ui.autoValue || width === $dyn.layout.Size.content) {
                        width = $dyn.layout.Size.large;
                    }
                    return width;
                }, function (value) {
                    $dyn.setValue(_this, "Width", value);
                });
                // Note the Input control would make this observable if it wasn't already.
                this.InputValue = $dyn.observable("");
                this.TypedValue = $dyn.observable("");
                if ($dyn.value(this.PlaceholderText) === "") {
                    $dyn.setValue(this, "PlaceholderText", "QuickFilter_PlaceHolderText");
                }
                this.FieldPickerOpen = $dyn.observable(false);
                this.ShowFieldPicker = $dyn.computed(function () {
                    var pickerOpen = $dyn.value(_this.FieldPickerOpen);
                    var fieldList = $dyn.value(_this.FieldList);
                    var fieldListEmpty = true;
                    if (fieldList && fieldList.length !== 0) {
                        fieldListEmpty = false;
                    }
                    return pickerOpen && !fieldListEmpty;
                }, function (newValue) {
                    _this.FieldPickerOpen(newValue);
                });
                this.selectedIndex = $dyn.observable(-1);
                this.preSelectedIndex = -1;
                this.previousValue = "";
                $dyn.observe(this.Value, function (newValue) {
                    // Observe filterValue so input value can be updated when it changes on the server.
                    // We can't bind the Input control's value directly to the filterValue, otherwise whenever
                    // a user types, the focus will be set to the end of the control since TextChanged would be
                    // called after every character press.
                    _this.InputValue(newValue);
                    _this.TypedValue(newValue);
                    if (newValue) {
                        _this.$controlElement.addClass("noPlaceHolder");
                        _this.$controlElement.addClass("quickFilter-isApplied"); // The value changes should correspond with applied filters
                    }
                    else {
                        _this.$controlElement.removeClass("noPlaceHolder");
                        _this.$controlElement.removeClass("quickFilter-isApplied");
                    }
                });
                $dyn.observe(this.selectedIndex, this.updateAriaAttributes, this);
            };
            /**
             * Get the list of labels to display in the field selection dropdown.
             * @internal
             */
            QuickFilter.prototype.getFieldsForFlyout = function () {
                if (this.FieldLabels.length > 0) {
                    return this.FieldLabels;
                }
                return this.FieldList;
            };
            /**
             * Event handler that is executed when the children of the QuickFilter have been databound. Used to update aria-labels.
             * @internal
             */
            QuickFilter.prototype.postDataBindChildren = function () {
                // After the children of the quickfilter are databound, find the input element and update its aria tag
                var $inputElement = this.$controlElement.find(".field");
                $inputElement.attr("aria-controls", $dyn.value(this.Id) + "_listbox");
                $inputElement.attr("aria-activedescendant", null);
            };
            /**
             * Open the dropdown containing the available fields to filter on.
             * @internal
             */
            QuickFilter.prototype.openFieldPicker = function () {
                var _this = this;
                this.callRefreshFilter().always(function () {
                    // Open the filter always even if server refresh call fails
                    // If refresh fails it will show old list
                    _this.ShowFieldPicker(true);
                    _this.resetSelectedIndex();
                    _this.updateAriaAttributes();
                });
            };
            /**
             * Refreshes quickfilter field list async
             * @internal
             */
            QuickFilter.prototype.callRefreshFilter = function () {
                var deferred = $.Deferred();
                var commandCallback = function () {
                    deferred.resolve();
                };
                var failureCallback = function () {
                    deferred.reject();
                };
                var retVal = $dyn.callFunction(this.Refresh, this, undefined, commandCallback, null /*complete*/, null /*before*/, null /*throttle*/, failureCallback);
                if (retVal === null) {
                    deferred.reject();
                }
                return deferred.promise();
            };
            /**
             * Close the dropdown containing the available fields to filter on.
             * @internal
             */
            QuickFilter.prototype.closeFieldPicker = function () {
                this.ShowFieldPicker(false);
                var $inputElement = this.$controlElement.find("input").first();
                $inputElement.removeAttr("aria-activedescendant");
                $inputElement.removeAttr("aria-controls");
            };
            /**
             * Update the aria tags to reflect which field is selected in the quickfilter
             * @internal
             */
            QuickFilter.prototype.updateAriaAttributes = function () {
                var selectedIndex = $dyn.value(this.selectedIndex);
                var $inputElement = this.$controlElement.find("input").first();
                if (selectedIndex > -1) {
                    $inputElement.attr("aria-activedescendant", $dyn.value(this.Id) + "_listbox_item" + selectedIndex);
                }
                else {
                    $inputElement.attr("aria-activedescendant", $dyn.value(this.Id) + "_listbox_item" + 0);
                }
            };
            /**
             * Get the field that is currently selected by the keyboard in the field selection dropdown.
             * Used when the enter key is pressed to determine which field should be filtered on.
             * If the dropdown is open, takes the field in focus in the dropdown. Else use the value stored in the Field property.
             * @internal
             */
            QuickFilter.prototype.selectedField = function () {
                var field = $dyn.value(this.Field);
                var fieldList = $dyn.value(this.FieldList);
                var selectedIndex = $dyn.value(this.selectedIndex);
                var dropDownOpen = $dyn.value(this.ShowFieldPicker);
                if (dropDownOpen && fieldList && fieldList.length > 0 && selectedIndex >= 0) {
                    field = fieldList[selectedIndex];
                }
                return field;
            };
            /**
             * Reset the selected index to the field that is selected. Use -1 there is no match.
             * @internal
             */
            QuickFilter.prototype.resetSelectedIndex = function () {
                var field = $dyn.value(this.Field);
                var items = $dyn.value(this.FieldList);
                var dropDownOpen = $dyn.value(this.ShowFieldPicker);
                if (dropDownOpen && field && items) {
                    for (var i = 0; i < items.length; i++) {
                        if (items[i] === field) {
                            this.selectedIndex(i);
                            return;
                        }
                    }
                }
                // Set selectedIndex to -1 if fieldList is null, or Field is not in FieldList
                this.selectedIndex(-1);
            };
            /**
             * Gets label for the QuickFilter operator to show in the UI based on the dataType of the field at the specified index.
             * If the index is null or no fieldType is found use string as the fieldType
             * @internal
             * @deprecated This is deprecated at 08/05/2020.Remove it TFS(478168).
             * @param index The index of the field to retrieve the operator for.
             */
            QuickFilter.prototype.getFilterOperator = function (index) {
                var typeString = $dyn.label("FilterOperators_Contains");
                if (index !== undefined) {
                    var fieldType = $dyn.value(this.FieldType)[index];
                    if (fieldType) {
                        switch (fieldType) {
                            case $dyn.controls.FilterField.DataTypes.Integer:
                            case $dyn.controls.FilterField.DataTypes.Int64:
                            case $dyn.controls.FilterField.DataTypes.Real:
                            case $dyn.controls.FilterField.DataTypes.Guid:
                            case $dyn.controls.FilterField.DataTypes.Date:
                            case $dyn.controls.FilterField.DataTypes.UtcDateTime:
                            case $dyn.controls.FilterField.DataTypes.Time:
                                typeString = $dyn.label("FilterOperators_Is");
                                break;
                            case $dyn.controls.FilterField.DataTypes.Enum:
                                var fieldName = $dyn.value(this.FieldName)[index];
                                if (fieldName && fieldName === $dyn.util.dataAreaId) {
                                    typeString = $dyn.label("FilterOperators_Is");
                                }
                                typeString = $dyn.label("FilterOperators_BeginsWith");
                                break;
                            default:
                                typeString = $dyn.label("FilterOperators_Contains");
                                break;
                        }
                    }
                }
                return typeString;
            };
            /**
             * Clear the existing quickfilter and any text in the input.
             * @internal
             * @deprecated This is deprecated at 08/05/2020.Remove it TFS(478168).
             */
            QuickFilter.prototype.callClearFilter = function () {
                this.InputValue("");
                this.TypedValue("");
                this.$controlElement.removeClass("noPlaceHolder");
                this.$controlElement.removeClass("quickFilter-isApplied");
                this.callApplyFilter();
            };
            /**
             * Selects the next item in the QuickFilter dropdown. Opens the dropdown if not already open.
             * @internal
             */
            QuickFilter.prototype.nextItem = function () {
                var nextIndex = $dyn.value(this.selectedIndex) + 1;
                var items = $dyn.value(this.FieldList);
                if (items && nextIndex < items.length) {
                    this.selectedIndex(nextIndex);
                }
            };
            /**
             * Selects the previous item in the QuickFilter dropdown. Opens the dropdown if not already open.
             * @internal
             */
            QuickFilter.prototype.previousItem = function () {
                var previousIndex = $dyn.value(this.selectedIndex) - 1;
                if (previousIndex >= 0) {
                    this.selectedIndex(previousIndex);
                }
            };
            /**
             * Get active descendant element for quick filter menu
             * @internal
             * @deprecated This is only used in test. This is deprecated at 08/05/2020.Remove it TFS(478168).
             */
            QuickFilter.prototype.getActiveDescendant = function () {
                var selectedIndex = $dyn.value(this.selectedIndex);
                if (selectedIndex <= -1) {
                    selectedIndex = 0;
                }
                var activeDescendantElementId = $dyn.value(this.Id) + "_list_item" + selectedIndex;
                return activeDescendantElementId;
            };
            return QuickFilter;
        }($dyn.ui.Control));
        controls.QuickFilter = QuickFilter;
        QuickFilter.prototype.ApplyFilter = null;
        QuickFilter.prototype.FieldList = [];
        QuickFilter.prototype.FieldType = [];
        QuickFilter.prototype.FieldLabels = [];
        QuickFilter.prototype.PlaceholderText = "";
        QuickFilter.prototype.recordability = $dyn.util.recordabilityDefault;
        $dyn.ui.addObservablePropertiesToPrototype(QuickFilter.prototype, {
            Field: "",
            Value: ""
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=QuickFilter.js.map
